/*
 * Copyright 2018-present Evernote Corporation. All rights reserved.
 */

import createLogger from 'ion-logger';
import AbstractConfigLoader from '../lib/AbstractConfigLoader';

const logger = createLogger('ion:config:BaseEmbedLoader');

/**
 * Loader for getting service config values injected into the "baseEmbed" script.
 */
class BaseEmbedLoader extends AbstractConfigLoader {
  getEmbeddedJson(): { [key: string]: any } | null | undefined {
    let jsonBlob;
    if (typeof window === 'object' && typeof window.__ionOpts === 'object') {
      jsonBlob = window.__ionOpts;
      logger.info(`BaseEmbedLoader._values = ${JSON.stringify(jsonBlob, null, 2)}`);
    } else if (typeof document === 'object') {
      const elem = document.getElementById('baseEmbed');
      if (elem && elem.innerText) {
        try {
          jsonBlob = JSON.parse(elem.innerText);
        } catch (error) {
          return null;
        }
      }
    }
    return jsonBlob;
  }

  async init(): Promise<void> {
    if (this._values == null) {
      this._values = this.getEmbeddedJson() || {};
    }
  }
}

export default new BaseEmbedLoader();
